<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large" style="min-height: 80%">
      <header class="modal-card-head">
        <p class="modal-card-title">Ticket Config</p>
      </header>
      <section class="modal-card-body">
        <table class="table">
          <tr>
            <th>Subject</th>
            <th>Internal User</th>
          </tr>
          <tr v-for="(subject, index) in subjects" :key="subject.id">
            <td>{{ subject.subject }}</td>
            <td>
              <v-select ref="select" :options="parseUser()" v-model="internal_users[index]" multiple item-value placeholder="Not assigned"></v-select>
            </td>
          </tr>
        </table>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true}" @click="save()">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  // import babelPolyfill from 'babel-polyfill'
  import vSelect from 'vue-select'
  // import 'vue-select/dist/vue-select.css'
  import message from '../../../client/utils/message'
  export default {
    props: {
      context: {
        type: Object
      },
      users: {
        type: Array,
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        subjects: [],
        internal_users: []
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
        this.loadData()
      })
    },
    methods: {
      parseUser () {
        let userTmp = this.users.map((user) => {
          return {
            label: user.name,
            value: user.id
          }
        })
        return userTmp
      },
      loadData () {
        let userName = ''
        this.context.$http.get(this.context.$store.state.config.apiURL + '/occurrences_customer/subject/all', { params: { 'internal': 3 } }).then(responseSubject => {
          this.subjects = responseSubject.body
          this.internal_users = responseSubject.body.map((subject) => {
            if (subject.user_id) {
              let UserIdSplit = subject.user_id.split(',')
              let UserTmp = UserIdSplit.map((user) => {
                this.users.forEach(element => {
                  if (parseInt(user) === element.id) {
                    userName = element.name
                  }
                })
                return {
                  label: userName,
                  value: user
                }
              })
              return UserTmp
            }
          })
        })
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      save () {
        this.context.$http.post(this.context.$store.state.config.apiURL + '/occurrences_customer/occurrence_config', { users: this.internal_users }).then(response => {
          this.close(false, 'ok')
        }, (response) => {
          this.close(false, response.body.message)
        })
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    },
    components: {
      // babelPolyfill,
      vSelect
    }
  }
</script>
<style scoped>
  th, td {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// OccurrenceConfig.vue?334d7c50